export const majaData = {
    designs: {
        title: 'High-fidelity designs',
        images: {
            mobile: [
                'maja_mobile_1.png',
                'maja_mobile_2.png',
                'maja_mobile_3.png',
                'maja_mobile_4.png'
            ]
        }
    }
}
